$(function () {
    var mqDesktop = 768;

    function displayIsBiggerThanBreakpoint(bp) {
        var displayWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return displayWidth >= bp;
    }
    // var $body = $('body');


    // DROP BUBBLE NAVIGATION
    // ---------------------------------------------------------------------------
    $.fn.extend({
        dropBubbule: function () {

            return this.each(function () {
                var self = $(this);
                self.find('[data-dropbubble="click"]').click(function (e) {
                    console.log(self);
                    self.toggleClass('drop-bubble--visible');
                });

                self.find('.mt-ProfilePhotoUpload-label').click(function (e) {
                    self.removeClass('drop-bubble--visible');
                });
            });
        }
    });

    $('[data-dropbubble="open"]').dropBubbule();


    // DROP BUBBLE MAIN NAVIGATION
    // ---------------------------------------------------------------------------
    function bindToggleDropdownBubbleNav() {
        if( displayIsBiggerThanBreakpoint( mqDesktop ) ) {
            $(document).on('click', '[data-dropbubble-nav="open"] > .nav_btn', function (e) {
                e.preventDefault();
            });
            $(document).on('mouseenter', '[data-dropbubble-nav="open"]', function () {
                $(this).addClass('drop-bubble--visible');
            });
            $(document).on('mouseleave', '[data-dropbubble-nav="open"]', function () {
                $(this).removeClass('drop-bubble--visible');
            });
        } else {
            $(document).off('click', '[data-dropbubble-nav="open"] > .nav_btn');
            $(document).off('mouseenter mouseleave', '[data-dropbubble-nav="open"]');
        }
    }

    // LOAD
    // ---------------------------------------------------------------------------
    if( displayIsBiggerThanBreakpoint(mqDesktop) ) {
        bindToggleDropdownBubbleNav();
    }

    // RESIZE
    // ---------------------------------------------------------------------------
    $(window).resize(function () {
        bindToggleDropdownBubbleNav();
    });
});
